import { render } from "./OTPModal.vue?vue&type=template&id=2f27001c&scoped=true"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"

import "./OTPModal.vue?vue&type=style&index=0&id=2f27001c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f27001c"]])

export default __exports__